import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProdutosPage } from './produtos';
import { ComponentsModule } from '../../components/components.module';
import { ProdutosPageProvider } from './produtos.provider';
import { ProdutosProvider } from '../../providers/products/products';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    ProdutosPage,
  ],
  imports: [
    ComponentsModule,
    PipesModule,
    IonicPageModule.forChild(ProdutosPage),
  ],
  providers: [
    ProdutosPageProvider,
    ProdutosProvider,
    InAppBrowser
  ]
})
export class ProdutosPageModule {}



// WEBPACK FOOTER //
// ./src/pages/produtos/produtos.module.ts